<template>
  <div id='Landing'>
    <ScrollListener v-slot='{ scroll }'>
      <Spot :scroll='scroll' />
    </ScrollListener>
    <SideBar />
    <MainNavigation v-if='kirby.page.template != "home"' />
    <transition name='basic'>
      <router-view id='Overlay' name='overlay'
        @addReasonToShowVeil='reasonsToShowTheVeil = reasonsToShowTheVeil+1'
        @removeReasonToShowVeil='reasonsToShowTheVeil = reasonsToShowTheVeil-1'
        :key='kirby.page.uri' />
    </transition>
    <veil :showveil='reasonsToShowTheVeil' />
    <transition name='basic'>
      <router-view name='main' />
    </transition>
  </div>
</template>

<style scoped>
  main {
    height: 100%;
  }

  main#Overlay {
    position: fixed;
    z-index: var(--overlayz);
    background-color: rgba(255,255,255,0.95);
    padding: var(--overlaypadding);
    overflow-y: scroll;
    border: var(--thinline);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    box-sizing: border-box;
    margin: auto;
    width: var(--overlaywidth);
    height: var(--overlayheight);
  }

  main {
    scrollbar-width: thin;
    scrollbar-color: var(--gray) var(--gray);
  }

  main::-webkit-scrollbar {
    width: 0.3rem;
  }

  main::-webkit-scrollbar-thumb {
    background-color: var(--gray);
    border-radius: 0;
  }

  .basic-enter-active, .basic-leave-active {
    transition: opacity 0.3s cubic-bezier(0.74,0.11,0.56,1);
  }
  .basic-enter, .basic-leave-to {
    opacity: 0;
  }

</style>

<script>
import mixins from '.././mixins.js';

export default {
  mixins: [mixins], //kirby(), urltopath(), etc
  data: function() {
    return {
      reasonsToShowTheVeil: 0,
    }
  },
  watch: {
    'kirby.page': {
      immediate: true,
      handler: function() {
        //document.title = this.kirby.page.content ? this.kirby.page.content.title.value : '';
      }
    },
    '$route': {
      immediate: true,
      handler: function(to, from) {
        this.fresh = (to.name=='Featured' && !from);
        this.from = from ? from.path : 'outside';
      }
    }
  },
}
</script>
